import { useCallback } from 'react';
import { gqlTalentUnionEnum as TALENT_UNION } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';

const unionText = {
  [TALENT_UNION.NON_UNION]: 'common:unionStatusOptions.NON_UNION',
  [TALENT_UNION.ACTRA]: 'common:unionStatusOptions.ACTRA',
  [TALENT_UNION.AEA]: 'common:unionStatusOptions.AEA',
  [TALENT_UNION.CAEA]: 'common:unionStatusOptions.CAEA',
  [TALENT_UNION.EQUITY]: 'common:unionStatusOptions.EQUITY',
  [TALENT_UNION.MEAA]: 'common:unionStatusOptions.MEAA',
  [TALENT_UNION.ELIGIBLE]: 'common:unionStatusOptions.ELIGIBLE',
  [TALENT_UNION.FICORE]: 'common:unionStatusOptions.FICORE',
  [TALENT_UNION.MEMBER]: 'common:unionStatusOptions.MEMBER',
  [TALENT_UNION.SAG_AFTRA]: 'common:unionStatusOptions.SAG_AFTRA',
  [TALENT_UNION.UBCP_ACTRA]: 'common:unionStatusOptions.UBCP_ACTRA',
  [TALENT_UNION.UDA]: 'common:unionStatusOptions.UDA',
  [TALENT_UNION.NO_UNION_AFFILIATION]: 'common:unionStatusOptions.NO_UNION_AFFILIATION',
  [TALENT_UNION.OTHER]: 'common:unionStatusOptions.OTHER',
};

export const useUnionTypesText = (): ((unionCode: keyof typeof TALENT_UNION) => string) => {
  const { t } = useTranslation();

  return useCallback(
    (unionCode) => {
      const key = unionText[unionCode];

      return key ? t(key) : '';
    },
    [t]
  );
};
